module.exports = __webpack_public_path__ + "static/img/产品商机.51669596.svg";